import React, { useState, useEffect } from 'react';
import './formulario.css';
import API from "../../providers/api";
import { Card, CardBody, Input, Button, Form, UncontrolledCollapse, Spinner } from "reactstrap"
import logo from '../../assets/img/logo.png'
import success from '../../assets/img/success.png'
import fail from '../../assets/img/fail.png'
import warning from '../../assets/img/warning.png'
import { alert } from '../../helpers/alert';
import moment from 'moment'
import md5 from 'md5';
import bannerErrorFirmaDigital from '../../assets/img/imagen-left.jpg'

const Response = () => {
    const [transactionId, setTransactionId] = useState('');
    const [extra1, setExtra1] = useState('');
    const [reference_pol, setReference_pol] = useState('');
    const [referenceCodeForm, setReferenceCodeForm] = useState('');
    const [transactionStateForm, setTransactionStateForm] = useState('');
    const [transactionStateMsjForm, setTransactionStateMsjForm] = useState('');
    const [lapPaymentMethod, setLapPaymentMethod] = useState('');
    const [description, setDescription] = useState('');
    const [currency, setCurrency] = useState('');
    const [pseBank, setPseBank] = useState('');
    const [cus, setCus] = useState('');
    const [valueFormat, setValueFormat] = useState('');
    const [mostrarRespuesta, setMostrarRespuesta] = useState(false);
    const apiKey = process.env.REACT_APP_APIKEY;

    const formatCash = Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
    });

    useEffect(() => {
        const queryParameters = new URLSearchParams(window.location.search)
        const merchantId = queryParameters.get("merchantId")
        const lapTransactionState = queryParameters.get("lapTransactionState")
        const extra_1 = queryParameters.get("extra1")
        setExtra1(queryParameters.get("extra1"))
        const referenceCode = queryParameters.get("referenceCode")
        setReferenceCodeForm(queryParameters.get("referenceCode"))
        const transactionState = queryParameters.get("transactionState")
        setTransactionStateForm(queryParameters.get("transactionState"))
        const mensaje = queryParameters.get("mensaje")
        setTransactionStateMsjForm(queryParameters.get("mensaje"))
        const description = queryParameters.get("description")
        setDescription(queryParameters.get("description"))
        const buyerEmail = queryParameters.get("buyerEmail")
        const tx_value = queryParameters.get("TX_VALUE")
        const newTx_Value = tx_value.substring(0, tx_value.length - 1);
        setValueFormat(formatCash.format(tx_value))
        const lapPayment_Method = queryParameters.get("lapPaymentMethod")
        setLapPaymentMethod(queryParameters.get("lapPaymentMethod"))
        const processingDate = queryParameters.get("processingDate")
        const transaction_Id = queryParameters.get("transactionId")
        setTransactionId(queryParameters.get("transactionId"))
        const referencePol = queryParameters.get("reference_pol")
        setReference_pol(queryParameters.get("reference_pol"))
        const pse_Bank = queryParameters.get("pseBank")
        setPseBank(queryParameters.get("pseBank"))
        const cus_ = queryParameters.get("cus")
        setCus(queryParameters.get("cus"))
        const currency_ = queryParameters.get("currency")
        setCurrency(queryParameters.get("currency"))
        const signature = queryParameters.get("signature")
        const armarSignature = md5(`${apiKey}~${merchantId}~${referenceCode}~${newTx_Value}~COP~${transactionState}`)
        if(signature == armarSignature){
            setMostrarRespuesta(true)
            if(sessionStorage.getItem('arrayCompetidores') != ""){
                const data = JSON.parse(sessionStorage.getItem('arrayCompetidores'))
                if(data.length > 0){
                    API.guardarRegistroInscripcion(sessionStorage.getItem('arrayCompetidores'), merchantId, lapTransactionState, extra_1, referenceCode, transactionState, mensaje, description, buyerEmail, tx_value, lapPayment_Method, processingDate, transaction_Id, referencePol, pse_Bank, cus_ != "" ? cus_ : '-', currency_, signature, armarSignature)
                    .then(data => data.json())
                    .then(dataJson => {
                        console.log(dataJson)
                    })
                    .catch((e) => {
                        console.log("Error =>", e)
                    })
                }else{
                    return alert('Warning!', `Proceso realizado pero no se pudo inscribir los competidores. Comuníquese con el administrador del sistema.`, 'warning', 'Closed');
                }
            }else{
                return alert('Warning!', `Proceso realizado pero no se pudo inscribir los competidores. Comuníquese con el administrador del sistema.`, 'warning', 'Closed');
            }
        }
        console.log(window.sessionStorage.getItem('arrayCompetidores'))
    }, [])

    return (
        <div className='flex-container'>
                    <div>
                        <Card style={{ opacity: '0.9' }}>
                            <div className='row'>
                                <div className='col-lg-1'></div>
                                <div className='col-lg-10 text-center'>
                                    <a href="#">
                                        <img style={{width:'100%',maxWidth:'150px'}} src={logo} className='logoWidth' />
                                    </a>
                                </div>
                                <div className='col-lg-1'></div>
                            </div>
                            {
                                mostrarRespuesta ?
                                <div className='row mt-4'>
                                    <div className='col-lg-2'></div>
                                    <div className='col-lg-8 text-center' style={{borderTop: '2px solid #FF3366'}}>
                                        <div className="panel-body mt-4">
                                            <div className="row">
                                                <div className="col-md-5">
                                                <label>Estado de la transacción:</label>
                                                </div>
                                                <div className="col-md-6">
                                                {
                                                    transactionStateForm == 4 ?
                                                    <b style={{color:'green'}}>Transacción APROBADA</b>
                                                    : transactionStateForm == 6 ?
                                                    <b style={{color:'red'}}>Transacción RECHAZADA</b>
                                                    : transactionStateForm == 104 ?
                                                    <b style={{color:'red'}}>ERROR</b>
                                                    : transactionStateForm == 7 ?
                                                    <b style={{color:'blue'}}>Transacción PENDIENTE</b>
                                                    : <b>{transactionStateMsjForm}</b>
                                                }
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-5">
                                                <label>ID de la transacción:</label>
                                                </div>
                                                <div className="col-md-6 text-bold">
                                                    {transactionId}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-5">
                                                <label>Documento de Identidad:</label>
                                                </div>
                                                <div className="col-md-6">
                                                {extra1}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-5">
                                                <label>Referencia de la venta en PayU:</label>
                                                </div>
                                                <div className="col-md-6 text-bold">
                                                {reference_pol}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-5">
                                                <label>Referencia de la transacción:</label>
                                                </div>
                                                <div className="col-md-6 text-bold">
                                                {referenceCodeForm}
                                                </div>
                                            </div>
                                            {
                                                pseBank != "" ?
                                                <>
                                                    <div className="row">
                                                        <div className="col-md-5">
                                                        <label>CUS:</label>
                                                        </div>
                                                        <div className="col-md-6">
                                                        {cus}
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-5">
                                                        <label>Banco:</label>
                                                        </div>
                                                        <div className="col-md-6">
                                                        {pseBank}
                                                        </div>
                                                    </div>
                                                </>
                                                : ''
                                            }
                                            <div className="row">
                                                <div className="col-md-5">
                                                <label>Valor total:</label>
                                                </div>
                                                <div className="col-md-6 text-bold">
                                                {valueFormat}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-5">
                                                <label>Moneda:</label>
                                                </div>
                                                <div className="col-md-6 text-bold">
                                                {currency}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-5">
                                                <label>Descripción:</label>
                                                </div>
                                                <div className="col-md-6">
                                                {description}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-5">
                                                <label>Medio de Pago/Franquicia:</label>
                                                </div>
                                                <div className="col-md-6">
                                                {lapPaymentMethod}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='mt-4' align="center"><button className="btn btn-primary" onClick={() => window.print()}><i className="fa fa-print"></i> Imprimir Recibo</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            <a style={{cursor:'pointer'}} className="btn btn-success" href="./" ><i className="fa fa-sign-out"></i> Terminar</a></div>
                                        </div>
                                </div>
                                : <img src={bannerErrorFirmaDigital} style={{width:'100%'}} />
                            }
                            <div className='row mt-4'>
                                <div className='col-lg-12 text-center text-bold'>
                                © 2023 FUNDEPORTIVA - Todos los derechos reservados
                                </div>
                            </div>
                        </Card>
                    </div>
        </div>
    );
}

export default Response;